import React from 'react';
import InfoButton from './InfoButton';

// Hover text for the Presentation Mode switches (header and room settings).
export const PRESENTATION_MODE_TOOLTIP = 'Limit what your audience can do while you present';

export const PRESENTATION_MODE_HELP_HREF = '/help#presentation-mode';

/**
 * The "i" button that sits next to every Presentation Mode switch, so the
 * header and the Settings panel explain it in the same words.
 */
export default function PresentationModeInfo({ sx }) {
    return (
        <InfoButton title='Presentation Mode' learnMoreHref={PRESENTATION_MODE_HELP_HREF} sx={sx}>
            Turn this on while you present to keep your audience focused on your slides. Your audience
            loses the features you have switched off under Settings (by default, drawing and the
            Image Q). Room admins keep everything. Turn it off to give everyone full access again.
        </InfoButton>
    );
}
